/* eslint-disable quote-props */
import Vue from 'vue';
import Vuex from 'vuex';

import appData from './app-data';
import auth from './auth';
import http from './http';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    'app-data': appData,
    'auth': auth,
    'http': http,
  },
});
